export default __webpack_public_path__ + "static/media/food2.ade61e7f.jpg";